// src/components/Layout.jsx
// The wrapper that puts Header above and Footer below every page.
// Imported into App.js and wrapped around all <Route> elements.
//
// How it works: Layout receives a `children` prop, which is whatever JSX is
// rendered inside its tags. That's the active page. We render Header,
// then children, then Footer. The result: every page gets consistent chrome
// without each page having to import Header and Footer itself.
//
// Note: Navigation is rendered inside Header, not separately here.
// The spec lists it as part of Layout's responsibilities, but the visible
// outcome is the same: Navigation appears once at the top of every page.
import Header from "./Header";
import Footer from "./Footer";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-paper text-ink">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
